module.exports = "/static/assets/c9dd72975cc161133dc267e735f7835f.png";